import { render } from "./PlayerCompareModal.vue?vue&type=template&id=30dfeec4"
import script from "./PlayerCompareModal.vue?vue&type=script&lang=js"
export * from "./PlayerCompareModal.vue?vue&type=script&lang=js"

import "./PlayerCompareModal.vue?vue&type=style&index=0&id=30dfeec4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__